import { apiClient } from "./client";

export type PlanningComment = {
  id: string;
  planning_id: string;
  author_user_id: string | null;
  author_email: string | null;
  author_full_name: string | null;
  body: string;
  created_at: string;
  updated_at: string;
};

export async function listPlanningComments(
  planningId: string,
): Promise<PlanningComment[]> {
  const { data } = await apiClient.get<PlanningComment[]>(
    `/api/v1/plannings/${planningId}/comments`,
  );
  return data;
}

export async function createPlanningComment(
  planningId: string,
  body: string,
): Promise<PlanningComment> {
  const { data } = await apiClient.post<PlanningComment>(
    `/api/v1/plannings/${planningId}/comments`,
    { body },
  );
  return data;
}

export async function patchPlanningComment(
  planningId: string,
  commentId: string,
  body: string,
): Promise<PlanningComment> {
  const { data } = await apiClient.patch<PlanningComment>(
    `/api/v1/plannings/${planningId}/comments/${commentId}`,
    { body },
  );
  return data;
}

export async function deletePlanningComment(
  planningId: string,
  commentId: string,
): Promise<void> {
  await apiClient.delete(
    `/api/v1/plannings/${planningId}/comments/${commentId}`,
  );
}
